import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import CouponDetailModal from '../../../../views/coupon/common/modal/CouponDetailModal';
import { couponActions } from '../../../../store/modules/coupon';

class CouponDetailModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'couponDetailModal', value: false });
  };

  render() {
    return <CouponDetailModal {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.couponDetailModal.isOpen,
    data: state.coupon.couponDetailModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(CouponDetailModalContainer));
